document.addEventListener('DOMContentLoaded', function () {
    /**
     * 閉じるボタンのイベント
     */
    const btnExit = document.querySelector('.popupCloseBt');
    if (!btnExit) {
        return;
    }

    btnExit.addEventListener('click', function () {
        window.close();
    });

    /**
     * 受注情報編集ボタンのイベント
     */
    const btnOrdersEdit = document.querySelectorAll('.js-open-opener-window');
    if (!btnOrdersEdit) {
        return;
    }

    btnOrdersEdit.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
        e.preventDefault();

        if (window.opener && !window.opener.closed) {
            // 現在のブラウザの表示幅・高さを取得
            const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
            const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
            // 新しいウィンドウで受注情報編集画面を開く
            window.open(e.currentTarget.href, 'orderEditPopup', `width=${width},height=${height},scrollbars=yes`);
        }
        });
    });
});